import React from 'react';
import PropTypes from 'prop-types';
import APAutoTabInput from '../common/APAutoTabInput/APAutoTabInput';
import path from '../../helpers/path';
import { getBEMClasses } from '../../helpers/cssClassesHelper';
import { required } from '../../helpers/formValidations';
import { Redirect } from 'react-router-dom';
import '../../styles/components/common/StandaloneForm.css';
import './TwoFactorAuthFormComponent.css';
var baseClasses = getBEMClasses('standalone-form');
var twoFactorAuthFormClasses = getBEMClasses('two-factor-auth-form');
export var TwoFactorAuthFormComponent = function TwoFactorAuthFormComponent(props, context) {
  var handleSubmit = props.handleSubmit,
    is2FARequired = props.is2FARequired,
    error = props.error;
  if (!is2FARequired) return React.createElement(Redirect, {
    to: path('/login')
  });
  return React.createElement('div', {
    className: baseClasses('container') + ' ' + twoFactorAuthFormClasses('container')
  }, React.createElement('div', {
    className: baseClasses('header') + ' ' + twoFactorAuthFormClasses('header')
  }, React.createElement('div', {
    className: baseClasses('header-text') + ' ' + twoFactorAuthFormClasses('header-text')
  }, context.t('Two-Factor Authentication'))), React.createElement('form', {
    onSubmit: handleSubmit,
    className: baseClasses('form') + ' ' + twoFactorAuthFormClasses('form')
  }, React.createElement('div', {
    className: baseClasses('information-text') + ' ' + twoFactorAuthFormClasses('information-text')
  }, context.t('Enter the token from your Authenticator app.')), React.createElement('div', {
    className: baseClasses('auto-tab-input')
  }, React.createElement(APAutoTabInput, {
    name: 'code',
    type: 'input',
    numberOfInputs: 6,
    validate: [required],
    customClass: twoFactorAuthFormClasses('input')
  }), error && React.createElement('div', {
    className: baseClasses('error') + ' ' + twoFactorAuthFormClasses('error')
  }, error))));
};
TwoFactorAuthFormComponent.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
  submitting: PropTypes.bool.isRequired
};
TwoFactorAuthFormComponent.contextTypes = {
  t: PropTypes.func.isRequired
};
export default TwoFactorAuthFormComponent;